export const themes = {
    // ===================================================================
    // TEMA 1: SOL POENTE (Escuro)
    // Conceito: Um tema escuro, quente e rústico, inspirado no pôr do sol
    // na fazenda. Usa tons de marrom profundo e laranja queimado.
    // ===================================================================
    'sol poente': {
        '--bg-main': '#3E2723', // Marrom café bem escuro
        '--bg-header': '#2D1B19', // Marrom quase preto
        '--bg-card': '#4E342E', // Marrom médio
        '--bg-footer': '#2D1B19', // Marrom quase preto
        '--text-main': '#EDE7E5', // Branco-creme
        '--text-hero': '#FFFFFF', // Branco puro
        '--text-secondary': '#D7CCC8', // Creme-claro
        '--color-accent': '#FF9800', // Laranja vibrante (preço)
        '--color-button-buy': '#FF9800', // Laranja vibrante (CTA principal)
        '--color-button-buy-hover-bg': '#FB8C00', // Laranja mais escuro
        '--card-feature-bg': '#5D4037', // Marrom (integrado ao tema)
        '--card-feature-text': '#FFCC80', // Laranja-pêssego (para ler no marrom)
        '--card-feature-border': 'transparent', // Sem borda, o fundo já destaca
        '--border-light': '#5D4037', // Borda com tom de marrom

        // Detalhes
        '--color-hero-button-bg': '#E65100', // Laranja queimado (forte)
        '--color-hero-button-hover-bg': '#D44C00',
        '--color-hero-button-text': '#FFFFFF',
        '--bg-image-placeholder': '#5D4037',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#3E2723',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#5D4037', // Tag usa cor do tema
        '--color-tag-text': '#EDE7E5',
        '--bg-icon-button': '#5D4037', // Botões +/-
        '--color-icon-button-border': '#6D4C41',
        '--color-icon-button-text': '#EDE7E5',
        '--bg-icon-button-hover': '#6D4C41',
        '--bg-icon-button-disabled': '#4E342E',
        '--color-icon-button-disabled-text': '#9E9E9E',
        '--bg-button-disabled': '#795548',
        '--color-footer-link': '#FF9800', // Link do footer com destaque
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA 2: MATA FRESCA (Escuro)
    // Conceito: Um tema natural, calmo e confiável. Usa tons de verde
    // musgo, cinza-azulado e detalhes em verde-limão.
    // ===================================================================
    'mata fresca': {
        '--bg-main': '#263238', // Azul-ardósia muito escuro
        '--bg-header': '#1C252A', // Quase preto
        '--bg-card': '#37474F', // Azul-ardósia médio
        '--bg-footer': '#1C252A',
        '--text-main': '#ECEFF1', // Branco-azulado
        '--text-hero': '#FFFFFF',
        '--text-secondary': '#B0BEC5', // Cinza-claro
        '--color-accent': '#AED581', // Verde-limão claro (preço)
        '--color-button-buy': '#8BC34A', // Verde-limão CTA
        '--color-button-buy-hover-bg': '#7CB342', // Verde-limão mais escuro
        '--card-feature-bg': '#455A64', // Tom de ardósia (integrado)
        '--card-feature-text': '#ECEFF1', // Texto claro
        '--card-feature-border': 'transparent',
        '--border-light': '#455A64', // Borda ardósia

        // Detalhes
        '--color-hero-button-bg': '#AED581', // Verde-limão claro
        '--color-hero-button-hover-bg': '#9CCC65',
        '--color-hero-button-text': '#263238', // Texto escuro para contraste
        '--bg-image-placeholder': '#455A64',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#263238',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#455A64', // Tag usa cor do tema
        '--color-tag-text': '#ECEFF1',
        '--bg-icon-button': '#455A64', // Botões +/-
        '--color-icon-button-border': '#546E7A',
        '--color-icon-button-text': '#ECEFF1',
        '--bg-icon-button-hover': '#546E7A',
        '--bg-icon-button-disabled': '#37474F',
        '--color-icon-button-disabled-text': '#90A4AE',
        '--bg-button-disabled': '#546E7A',
        '--color-footer-link': '#AED581',
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA 3: MANHÃ CLARA (Claro)
    // Conceito: Um tema claro, limpo e clássico. O "padrão" de apps
    // de fazenda, focado na clareza.
    // ===================================================================
    // manha clara: {
    //     '--bg-main': '#F8F9FA', // Cinza muito claro
    //     '--bg-header': '#FFFFFF', // Branco
    //     '--bg-card': '#FFFFFF', // Branco
    //     '--bg-footer': '#F1F3F5', // Cinza um pouco mais escuro
    //     '--text-main': '#212529', // Quase preto
    //     '--text-hero': '#000000', // Preto
    //     '--text-secondary': '#495057', // Cinza escuro
    //     '--color-accent': '#D6336C', // Rosa/Vinho forte (preço)
    //     '--color-button-buy': '#28a745', // Verde clássico
    //     '--color-button-buy-hover-bg': '#218838',
    //     '--card-feature-bg': '#FFFFFF', // Fundo branco
    //     '--card-feature-text': '#495057', // Texto cinza
    //     '--card-feature-border': '#E9ECEF', // Borda cinza clara
    //     '--border-light': '#DEE2E6', // Borda principal
    //
    //     // Detalhes
    //     '--color-hero-button-bg': '#0D6EFD', // Azul "bootstrap"
    //     '--color-hero-button-hover-bg': '#0B5ED7',
    //     '--color-hero-button-text': '#FFFFFF',
    //     '--bg-image-placeholder': '#E9ECEF',
    //     '--bg-carousel-nav': 'rgba(0, 0, 0, 0.5)',
    //     '--bg-carousel-nav-hover': 'rgba(0, 0, 0, 0.7)',
    //     '--color-carousel-nav-icon': '#FFFFFF',
    //     '--bg-icon-hover-light': 'rgba(0, 0, 0, 0.05)',
    //     '--bg-tag': '#E9ECEF', // Tag cinza claro
    //     '--color-tag-text': '#212529',
    //     '--bg-icon-button': '#F1F3F5', // Botões +/-
    //     '--color-icon-button-border': '#DEE2E6',
    //     '--color-icon-button-text': '#212529',
    //     '--bg-icon-button-hover': '#E9ECEF',
    //     '--bg-icon-button-disabled': '#F8F9FA',
    //     '--color-icon-button-disabled-text': '#ADB5BD',
    //     '--bg-button-disabled': '#CED4DA',
    //     '--color-footer-link': '#0D6EFD',
    //     '--bg-modal-overlay': 'rgba(0, 0, 0, 0.6)',
    // },

    // ===================================================================
    // TEMA 4: ARGILA (Claro)
    // Conceito: Um tema claro, mas quente e "cremoso".
    // Paleta em tons de creme, marrom e laranja.
    // ===================================================================
    // argila: {
    //     '--bg-main': '#FCFBF8', // Fundo creme
    //     '--bg-header': '#F6F3EE', // Creme mais escuro
    //     '--bg-card': '#FFFFFF', // Cartão branco
    //     '--bg-footer': '#F6F3EE',
    //     '--text-main': '#4E423B', // Texto marrom escuro
    //     '--text-hero': '#3E2723', // Título marrom
    //     '--text-secondary': '#6E5E53', // Texto secundário marrom
    //     '--color-accent': '#E65100', // Laranja-escuro (preço)
    //     '--color-button-buy': '#4CAF50', // Verde natural
    //     '--color-button-buy-hover-bg': '#43A047',
    //     '--card-feature-bg': '#F6F3EE', // Fundo creme (integrado)
    //     '--card-feature-text': '#4E423B', // Texto marrom
    //     '--card-feature-border': '#E0DACE', // Borda marrom claro
    //     '--border-light': '#E0DACE',
    //
    //     // Detalhes
    //     '--color-hero-button-bg': '#E65100', // Laranja escuro CTA
    //     '--color-hero-button-hover-bg': '#D44C00',
    //     '--color-hero-button-text': '#FFFFFF',
    //     '--bg-image-placeholder': '#E0DACE',
    //     '--bg-carousel-nav': 'rgba(0, 0, 0, 0.5)',
    //     '--bg-carousel-nav-hover': 'rgba(0, 0, 0, 0.7)',
    //     '--color-carousel-nav-icon': '#FFFFFF',
    //     '--bg-icon-hover-light': 'rgba(0, 0, 0, 0.05)',
    //     '--bg-tag': '#F6F3EE',
    //     '--color-tag-text': '#4E423B',
    //     '--bg-icon-button': '#F6F3EE', // Botões +/-
    //     '--color-icon-button-border': '#E0DACE',
    //     '--color-icon-button-text': '#4E423B',
    //     '--bg-icon-button-hover': '#E0DACE',
    //     '--bg-icon-button-disabled': '#FCFBF8',
    //     '--color-icon-button-disabled-text': '#B5A9A0',
    //     '--bg-button-disabled': '#D7CCC8',
    //     '--color-footer-link': '#E65100',
    //     '--bg-modal-overlay': 'rgba(0, 0, 0, 0.6)',
    // },

    // ===================================================================
    // TEMA 5: AROEIRA (Escuro)
    // Conceito: Um tema escuro sofisticado, com tons de vinho
    // profundo, rosa queimado e detalhes em dourado.
    // ===================================================================
    'aroeira': {
        '--bg-main': '#4A1C24', // Vinho muito escuro
        '--bg-header': '#311319', // Quase preto
        '--bg-card': '#6A2D3A', // Vinho médio
        '--bg-footer': '#311319',
        '--text-main': '#FFEBEE', // Rosa muito claro (creme)
        '--text-hero': '#FFFFFF',
        '--text-secondary': '#FFCDD2', // Rosa claro
        '--color-accent': '#FBC02D', // Dourado/Amarelo (preço)
        '--color-button-buy': '#D81B60', // Rosa choque/Magenta
        '--color-button-buy-hover-bg': '#C2185B',
        '--card-feature-bg': '#59232F', // Vinho (integrado)
        '--card-feature-text': '#FFEBEE', // Texto creme
        '--card-feature-border': 'transparent',
        '--border-light': '#884C5A', // Tom de vinho

        // Detalhes
        '--color-hero-button-bg': '#FBC02D', // Dourado CTA
        '--color-hero-button-hover-bg': '#F9A825',
        '--color-hero-button-text': '#4A1C24', // Texto escuro para contraste
        '--bg-image-placeholder': '#59232F',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#4A1C24',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#59232F',
        '--color-tag-text': '#FFEBEE',
        '--bg-icon-button': '#59232F', // Botões +/-
        '--color-icon-button-border': '#884C5A',
        '--color-icon-button-text': '#FFEBEE',
        '--bg-icon-button-hover': '#884C5A',
        '--bg-icon-button-disabled': '#6A2D3A',
        '--color-icon-button-disabled-text': '#E57373',
        '--bg-button-disabled': '#884C5A',
        '--color-footer-link': '#FBC02D',
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA 6: LIQUIDAÇÃO TOTAL (Claro)
    // Conceito: Um tema claro, brilhante e agressivo. Usa um fundo
    // branco puro para maximizar o contraste com CTAs em magenta
    // vibrante e destaques em amarelo-alerta. Foco total na urgência.
    // ===================================================================
    'liquidacao total': {
        '--bg-main': '#FFFFFF', // Branco puro
        '--bg-header': '#FFFFFF', // Header limpo
        '--bg-card': '#FFFFFF', // Card branco (com borda)
        '--bg-footer': '#F1F3F5', // Rodapé cinza claro
        '--text-main': '#212529', // Preto
        '--text-hero': '#000000', // Preto
        '--text-secondary': '#495057', // Cinza
        '--color-accent': '#D50000', // Vermelho "preço" forte
        '--color-button-buy': '#F50057', // Magenta vibrante (CTA)
        '--color-button-buy-hover-bg': '#C51162', // Magenta escuro
        '--card-feature-bg': '#FFD600', // Amarelo-alerta (Ex: "OFERTA")
        '--card-feature-text': '#1A1A1A', // Texto preto para ler no amarelo
        '--card-feature-border': 'transparent', // O fundo já é o destaque
        '--border-light': '#E0E0E0', // Borda cinza bem clara

        // Detalhes
        '--color-hero-button-bg': '#212529', // Botão hero preto (minimalista)
        '--color-hero-button-hover-bg': '#343A40',
        '--color-hero-button-text': '#FFFFFF',
        '--bg-image-placeholder': '#E9ECEF',
        '--bg-carousel-nav': 'rgba(0, 0, 0, 0.5)',
        '--bg-carousel-nav-hover': 'rgba(0, 0, 0, 0.7)',
        '--color-carousel-nav-icon': '#FFFFFF',
        '--bg-icon-hover-light': 'rgba(0, 0, 0, 0.05)',
        '--bg-tag': '#F1F3F5', // Tag cinza
        '--color-tag-text': '#212529',
        '--bg-icon-button': '#F1F3F5', // Botões +/-
        '--color-icon-button-border': '#DEE2E6',
        '--color-icon-button-text': '#212529',
        '--bg-icon-button-hover': '#E9ECEF',
        '--bg-icon-button-disabled': '#F8F9FA',
        '--color-icon-button-disabled-text': '#ADB5BD',
        '--bg-button-disabled': '#CED4DA',
        '--color-footer-link': '#F50057', // Link magenta
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.6)',
    },

    // ===================================================================
    // TEMA 7: NEON NOTURNO (Escuro)
    // Conceito: Um tema "tech" e energético. Fundo preto puro para
    // fazer os acentos "brilharem". Usa verde-limão neon para preços
    // e um roxo elétrico para CTAs, criando um visual digital e de alto impacto.
    // ===================================================================
    'neon noturno': {
        '--bg-main': '#121212', // Preto (Material Dark)
        '--bg-header': '#1E1E1E', // Quase preto
        '--bg-card': '#1E1E1E', // Card escuro
        '--bg-footer': '#121212', // Preto
        '--text-main': '#E0E0E0', // Branco-cinza
        '--text-hero': '#FFFFFF', // Branco puro
        '--text-secondary': '#AAAAAA', // Cinza médio
        '--color-accent': '#00E676', // Verde-limão neon (preço)
        '--color-button-buy': '#7B1AF7', // Roxo elétrico (CTA)
        '--color-button-buy-hover-bg': '#6200EA', // Roxo mais escuro
        '--card-feature-bg': '#333333', // Cinza escuro
        '--card-feature-text': '#00E676', // Texto neon (Ex: "FRETE GRÁTIS")
        '--card-feature-border': 'transparent',
        '--border-light': '#333333', // Borda cinza escura

        // Detalhes
        '--color-hero-button-bg': '#00E676', // Botão hero verde neon
        '--color-hero-button-hover-bg': '#00C853',
        '--color-hero-button-text': '#121212', // Texto preto para contraste
        '--bg-image-placeholder': '#333333',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#121212',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#333333', // Tag cinza
        '--color-tag-text': '#E0E0E0',
        '--bg-icon-button': '#333333', // Botões +/-
        '--color-icon-button-border': '#444444',
        '--color-icon-button-text': '#E0E0E0',
        '--bg-icon-button-hover': '#444444',
        '--bg-icon-button-disabled': '#1E1E1E',
        '--color-icon-button-disabled-text': '#757575',
        '--bg-button-disabled': '#444444',
        '--color-footer-link': '#00E676', // Link neon
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA 8: ONDA TROPICAL (Claro)
    // Conceito: Um tema claro, "clean" e de verão. Usa um fundo branco
    // levemente azulado com cores vibrantes de Ciano (piscina) e Laranja
    // (sol). Passa uma sensação de energia, frescor e oportunidade.
    // ===================================================================
    'onda tropical': {
        '--bg-main': '#F4F9FF', // Branco-azulado (muito claro)
        '--bg-header': '#FFFFFF', // Branco
        '--bg-card': '#FFFFFF', // Branco
        '--bg-footer': '#F4F9FF',
        '--text-main': '#334E68', // Azul-acinzentado escuro
        '--text-hero': '#102A43', // Azul-marinho
        '--text-secondary': '#627D98', // Azul-cinza médio
        '--color-accent': '#FF6F00', // Laranja-sol (preço)
        '--color-button-buy': '#00BCD4', // Ciano / Azul-piscina (CTA)
        '--color-button-buy-hover-bg': '#00ACC1', // Ciano mais escuro
        '--card-feature-bg': '#FFF3E0', // Pêssego bem claro (do laranja)
        '--card-feature-text': '#FF6F00', // Texto laranja
        '--card-feature-border': '#FFE0B2', // Borda pêssego
        '--border-light': '#DCEEFB', // Borda azul-claro

        // Detalhes
        '--color-hero-button-bg': '#FF6F00', // Botão hero laranja
        '--color-hero-button-hover-bg': '#E66300',
        '--color-hero-button-text': '#FFFFFF',
        '--bg-image-placeholder': '#DCEEFB',
        '--bg-carousel-nav': 'rgba(0, 0, 0, 0.5)',
        '--bg-carousel-nav-hover': 'rgba(0, 0, 0, 0.7)',
        '--color-carousel-nav-icon': '#FFFFFF',
        '--bg-icon-hover-light': 'rgba(0, 0, 0, 0.05)',
        '--bg-tag': '#E0F7FA', // Tag azul-ciano claro
        '--color-tag-text': '#006064',
        '--bg-icon-button': '#F4F9FF', // Botões +/-
        '--color-icon-button-border': '#DCEEFB',
        '--color-icon-button-text': '#334E68',
        '--bg-icon-button-hover': '#DCEEFB',
        '--bg-icon-button-disabled': '#F4F9FF',
        '--color-icon-button-disabled-text': '#9EADBB',
        '--bg-button-disabled': '#B0C4DE',
        '--color-footer-link': '#00BCD4', // Link Ciano
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.6)',
    },

    'alerta intenso': {
        '--bg-main': '#1A1A1A', // Cinza-carvão
        '--bg-header': '#111111', // Quase preto
        '--bg-card': '#2C2C2C', // Cinza-médio-escuro
        '--bg-footer': '#111111',
        '--text-main': '#F5F5F5', // Branco-sujo (melhor que #FFF)
        '--text-hero': '#FFFFFF', // Branco puro (OK para título grande)
        '--text-secondary': '#A0A0A0', // Cinza-claro
        '--color-accent': '#FFD600', // Amarelo-alerta (preço)
        '--color-button-buy': '#FF9100', // Laranja-segurança (CTA)
        '--color-button-buy-hover-bg': '#FF7A00', // Laranja mais forte
        '--card-feature-bg': '#FFD600', // Fundo amarelo para "OFERTA"
        '--card-feature-text': '#1A1A1A', // Texto preto para ler no amarelo
        '--card-feature-border': 'transparent',
        '--border-light': '#444444', // Borda cinza

        // Detalhes
        '--color-hero-button-bg': '#FFD600', // Botão hero amarelo
        '--color-hero-button-hover-bg': '#FFC100',
        '--color-hero-button-text': '#1A1A1A', // Texto preto
        '--bg-image-placeholder': '#2C2C2C',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#1A1A1A',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#444444',
        '--color-tag-text': '#F5F5F5',
        '--bg-icon-button': '#444444', // Botões +/-
        '--color-icon-button-border': '#555555',
        '--color-icon-button-text': '#F5F5F5',
        '--bg-icon-button-hover': '#555555',
        '--bg-icon-button-disabled': '#2C2C2C',
        '--color-icon-button-disabled-text': '#757575',
        '--bg-button-disabled': '#555555',
        '--color-footer-link': '#FFD600', // Link amarelo
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA 10: FOCO ELÉTRICO (Escuro)
    // Conceito: Um tema "tech" e moderno, quase "gamer". Fundo azul
    // muito escuro (em vez de preto) com CTAs em azul-elétrico e
    // preços em verde-limão. A ideia é "eletrizar" o olhar do usuário.
    // ===================================================================
    'foco eletrico': {
        '--bg-main': '#101419', // Azul-noite (quase preto)
        '--bg-header': '#0B0E11', // Mais escuro
        '--bg-card': '#1A2027', // Azul-ardósia escuro
        '--bg-footer': '#0B0E11',
        '--text-main': '#E8F1F8', // Branco-azulado
        '--text-hero': '#FFFFFF',
        '--text-secondary': '#B0C4DE', // Azul-claro-acinzentado
        '--color-accent': '#00E5FF', // Ciano-elétrico (preço)
        '--color-button-buy': '#3369FF', // Azul-cobalto vibrante (CTA)
        '--color-button-buy-hover-bg': '#1E58E5', // Azul mais escuro
        '--card-feature-bg': '#003B46', // Verde-petróleo/Ciano escuro
        '--card-feature-text': '#00E5FF', // Texto Ciano para "NOVO"
        '--card-feature-border': 'transparent',
        '--border-light': '#2A3B4D', // Borda azul-escura

        // Detalhes
        '--color-hero-button-bg': '#00E5FF', // Botão hero Ciano
        '--color-hero-button-hover-bg': '#00C4DD',
        '--color-hero-button-text': '#101419', // Texto escuro
        '--bg-image-placeholder': '#1A2027',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#101419',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.15)',
        '--bg-tag': '#2A3B4D',
        '--color-tag-text': '#E8F1F8',
        '--bg-icon-button': '#2A3B4D', // Botões +/-
        '--color-icon-button-border': '#3D5269',
        '--color-icon-button-text': '#E8F1F8',
        '--bg-icon-button-hover': '#3D5269',
        '--bg-icon-button-disabled': '#1A2027',
        '--color-icon-button-disabled-text': '#627D98',
        '--bg-button-disabled': '#3D5269',
        '--color-footer-link': '#00E5FF', // Link Ciano
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA 11: SEXTA-FEIRA QUENTE (Escuro)
    // Conceito: O tema clássico de "Black Friday" ou "Promoção".
    // Fundo preto/carvão, texto branco nítido e um vermelho
    // muito forte e saturado para CTAs e preços. Foco total em urgência.
    // ===================================================================
    'sexta feira quente': {
        '--bg-main': '#161616', // Cinza-carvão (quase preto)
        '--bg-header': '#0D0D0D', // Preto puro (para header fixo)
        '--bg-card': '#242424', // Cinza-escuro
        '--bg-footer': '#0D0D0D',
        '--text-main': '#FAFAFA', // Branco-sujo (confortável)
        '--text-hero': '#FFFFFF', // Branco puro
        '--text-secondary': '#B3B3B3', // Cinza-claro (estilo Netflix)
        '--color-accent': '#FF0000', // Vermelho puro (preço)
        '--color-button-buy': '#E50914', // Vermelho "Netflix" (CTA)
        '--color-button-buy-hover-bg': '#F40612', // Vermelho mais brilhante
        '--card-feature-bg': '#E50914', // Faixa vermelha (Ex: "PROMOÇÃO")
        '--card-feature-text': '#FFFFFF', // Texto branco na faixa
        '--card-feature-border': 'transparent',
        '--border-light': '#3A3A3A', // Borda cinza

        // Detalhes
        '--color-hero-button-bg': '#E50914', // Botão hero vermelho
        '--color-hero-button-hover-bg': '#F40612',
        '--color-hero-button-text': '#FFFFFF',
        '--bg-image-placeholder': '#242424',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#161616',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#3A3A3A', // Tag cinza
        '--color-tag-text': '#FAFAFA',
        '--bg-icon-button': '#3A3A3A', // Botões +/-
        '--color-icon-button-border': '#4F4F4F',
        '--color-icon-button-text': '#FAFAFA',
        '--bg-icon-button-hover': '#4F4F4F',
        '--bg-icon-button-disabled': '#242424',
        '--color-icon-button-disabled-text': '#757575',
        '--bg-button-disabled': '#4F4F4F',
        '--color-footer-link': '#E50914', // Link vermelho
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.85)',
    },

    // ===================================================================
    // TEMA 12: IMPULSO PÚRPURA (Escuro)
    // Conceito: Um tema criativo e "premium", mas vibrante. Usa um
    // roxo-beringela profundo como base. Os acentos são em verde-ácido
    // (para o preço, contraste máximo) e magenta (para o CTA).
    // ===================================================================
    'impulso purpura': {
        '--bg-main': '#2A1B3D', // Roxo-beringela escuro
        '--bg-header': '#1E102F', // Quase preto roxo
        '--bg-card': '#3E2A5B', // Roxo-médio
        '--bg-footer': '#1E102F',
        '--text-main': '#F3EFFF', // Branco-lavanda
        '--text-hero': '#FFFFFF',
        '--text-secondary': '#D0BFFF', // Lavanda-claro
        '--color-accent': '#ADFF2F', // Verde-ácido (preço)
        '--color-button-buy': '#F021B2', // Magenta / Rosa-choque (CTA)
        '--color-button-buy-hover-bg': '#D8119F', // Magenta mais escuro
        '--card-feature-bg': '#553F7A', // Roxo mais claro (integrado)
        '--card-feature-text': '#F3EFFF', // Texto lavanda
        '--card-feature-border': 'transparent',
        '--border-light': '#553F7A', // Borda roxa

        // Detalhes
        '--color-hero-button-bg': '#F021B2', // Botão hero magenta
        '--color-hero-button-hover-bg': '#D8119F',
        '--color-hero-button-text': '#FFFFFF',
        '--bg-image-placeholder': '#3E2A5B',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#2A1B3D',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.15)',
        '--bg-tag': '#553F7A',
        '--color-tag-text': '#F3EFFF',
        '--bg-icon-button': '#553F7A', // Botões +/-
        '--color-icon-button-border': '#6C5199',
        '--color-icon-button-text': '#F3EFFF',
        '--bg-icon-button-hover': '#6C5199',
        '--bg-icon-button-disabled': '#3E2A5B',
        '--color-icon-button-disabled-text': '#9E8AAF',
        '--bg-button-disabled': '#6C5199',
        '--color-footer-link': '#ADFF2F', // Link verde-ácido
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA NOVO 1: NINHO DE PALHA (Claro)
    // Conceito: Um tema claro, quente e rústico. Usa tons de creme,
    // bege ("amarelo queimado") e marrons claros, como um ninho.
    // O CTA é um laranja vibrante, lembrando uma gema forte.
    // ===================================================================
    'ninho de palha': {
        '--bg-main': '#FDFBF5', // Um bege/creme bem claro (casca de ovo "branca")
        '--bg-header': '#F5F0E9', // Bege levemente mais escuro
        '--bg-card': '#FFFFFF', // Cartão branco para contraste
        '--bg-footer': '#F5F0E9', // Mesmo bege do header
        '--text-main': '#5D4037', // Texto em marrom escuro (rústico)
        '--text-hero': '#4E342E', // Título em marrom mais profundo
        '--text-secondary': '#795548', // Marrom médio para subtextos
        '--color-accent': '#F57C00', // Laranja "gema" vibrante (preço)
        '--color-button-buy': '#FF9800', // Laranja "gema" (CTA principal)
        '--color-button-buy-hover-bg': '#FB8C00', // Laranja mais escuro
        '--card-feature-bg': '#FFF9C4', // Amarelo-palha bem claro
        '--card-feature-text': '#5D4037', // Texto marrom escuro
        '--card-feature-border': '#D7CCC8', // Borda marrom-clara
        '--border-light': '#D7CCC8', // Borda principal

        // Detalhes
        '--color-hero-button-bg': '#F57C00', // Laranja "gema"
        '--color-hero-button-hover-bg': '#E65100', // Laranja mais forte
        '--color-hero-button-text': '#FFFFFF',
        '--bg-image-placeholder': '#F5F0E9',
        '--bg-carousel-nav': 'rgba(0, 0, 0, 0.5)',
        '--bg-carousel-nav-hover': 'rgba(0, 0, 0, 0.7)',
        '--color-carousel-nav-icon': '#FFFFFF',
        '--bg-icon-hover-light': 'rgba(0, 0, 0, 0.05)',
        '--bg-tag': '#D7CCC8', // Tag em marrom-claro
        '--color-tag-text': '#5D4037',
        '--bg-icon-button': '#F5F0E9', // Botões +/-
        '--color-icon-button-border': '#D7CCC8',
        '--color-icon-button-text': '#5D4037',
        '--bg-icon-button-hover': '#EFEBE9',
        '--bg-icon-button-disabled': '#FDFBF5',
        '--color-icon-button-disabled-text': '#BCAAA4',
        '--bg-button-disabled': '#BCAAA4',
        '--color-footer-link': '#F57C00', // Link laranja
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.6)',
    },

    // ===================================================================
    // TEMA NOVO 2: VERDE ARAUCANA (Escuro)
    // Conceito: Um tema escuro inspirado nos ovos verdes/azulados.
    // Usa tons de verde-musgo profundo, marrom-escuro e um verde-claro
    // vibrante para os CTAs.
    // ===================================================================
    'verde araucana': {
        '--bg-main': '#333D29', // Marrom-oliva muito escuro
        '--bg-header': '#2C3523', // Quase preto
        '--bg-card': '#4A533F', // Verde-musgo/marrom médio
        '--bg-footer': '#2C3523',
        '--text-main': '#E8F5E9', // Verde-creme bem claro
        '--text-hero': '#FFFFFF', // Branco
        '--text-secondary': '#C5E1A5', // Verde-claro pálido
        '--color-accent': '#8BC34A', // Verde-limão (preço chamativo)
        '--color-button-buy': '#7CB342', // Verde "fresco" (CTA)
        '--color-button-buy-hover-bg': '#689F38', // Verde mais escuro
        '--card-feature-bg': '#A5D6A7', // O verde "casca de ovo" claro
        '--card-feature-text': '#2E402E', // Texto escuro para ler no verde-claro
        '--card-feature-border': 'transparent',
        '--border-light': '#4A533F', // Borda no tom do card

        // Detalhes
        '--color-hero-button-bg': '#8BC34A', // Verde-limão
        '--color-hero-button-hover-bg': '#9CCC65',
        '--color-hero-button-text': '#333D29', // Texto escuro
        '--bg-image-placeholder': '#4A533F',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#333D29',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#4A533F',
        '--color-tag-text': '#E8F5E9',
        '--bg-icon-button': '#4A533F', // Botões +/-
        '--color-icon-button-border': '#5B674E',
        '--color-icon-button-text': '#E8F5E9',
        '--bg-icon-button-hover': '#5B674E',
        '--bg-icon-button-disabled': '#333D29',
        '--color-icon-button-disabled-text': '#757575',
        '--bg-button-disabled': '#5B674E',
        '--color-footer-link': '#8BC34A', // Link verde
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA NOVO 3: ARDÓSIA E PALHA (Escuro)
    // Conceito: Tema escuro e elegante baseado nas screenshots.
    // Usa um fundo ardósia (azul-acinzentado escuro) com destaques
    // em palha/tan e um CTA verde vibrante.
    // ===================================================================
    'ardosia e palha': {
        '--bg-main': '#374151', // Azul-ardósia escuro
        '--bg-header': '#2D3748', // Um pouco mais escuro
        '--bg-card': '#4B5563', // Ardósia médio (cards de produto)
        '--bg-footer': '#2D3748', // Mais escuro
        '--text-main': '#F3F4F6', // Cinza bem claro (quase branco)
        '--text-hero': '#FFFFFF', // Branco puro
        '--text-secondary': '#D1D5DB', // Cinza claro (subtítulo hero)
        '--color-accent': '#E6D1B2', // Cor palha/tan (preço)
        '--color-button-buy': '#4CAF50', // Verde vibrante (CTA)
        '--color-button-buy-hover-bg': '#45A049', // Verde mais escuro
        '--card-feature-bg': '#E6D1B2', // Cor palha (fundo dos cards de feature)
        '--card-feature-text': '#78350F', // Texto marrom-escuro (nos cards de feature)
        '--card-feature-border': 'transparent', // Sem borda
        '--border-light': '#4B5563', // Borda sutil

        // Detalhes
        '--color-hero-button-bg': '#D9A44E', // Botão hero cor de palha
        '--color-hero-button-hover-bg': '#C09344', // Palha mais escuro
        '--color-hero-button-text': '#374151', // Texto escuro no botão hero
        '--bg-image-placeholder': '#4B5563',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#374151',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.1)',
        '--bg-tag': '#6B7280', // Fundo da tag "unidade"
        '--color-tag-text': '#F3F4F6', // Texto da tag "unidade"
        '--bg-icon-button': '#6B7280', // Botões +/-
        '--color-icon-button-border': '#7F8A97',
        '--color-icon-button-text': '#F3F4F6',
        '--bg-icon-button-hover': '#7F8A97',
        '--bg-icon-button-disabled': '#4B5563',
        '--color-icon-button-disabled-text': '#9CA3AF',
        '--bg-button-disabled': '#6B7280',
        '--color-footer-link': '#E6D1B2', // Link do footer
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },

    // ===================================================================
    // TEMA NOVO: MARROM ESCURO E PALHA (Escuro)
    // Conceito: substitui os tons ardósia por uma paleta de marrom escuro,
    // mantendo os destaques em palha/tan e o CTA verde.
    // ===================================================================
    'madeira e palha': {
        '--bg-main': '#3B2B2A', // Marrom escuro principal
        '--bg-header': '#2F2322', // Cabeçalho um pouco mais escuro
        '--bg-card': '#4A3633', // Cards de produto (marrom médio)
        '--bg-footer': '#2F2322', // Rodapé
        '--text-main': '#F5EFE6', // Texto principal (off-white para contraste)
        '--text-hero': '#FFFFFF', // Texto hero (branco puro)
        '--text-secondary': '#E6DACD', // Subtítulo/descrições
        '--color-accent': '#ff9e1c', // Cor palha/tan (preço e pequenos destaques) #ffa500, #E6D1B2
        '--color-button-buy': '#4CAF50', // Verde vibrante (CTA mantém-se)
        '--color-button-buy-hover-bg': '#45A049', // Hover do CTA
        '--card-feature-bg': '#E6D1B2', // Fundo dos cards de feature (palha)
        '--card-feature-text': '#4A2B1F', // Texto marrom-escuro nos cards de feature
        '--card-feature-border': 'transparent', // Sem borda
        '--border-light': '#4A3633', // Borda sutil

        // Detalhes
        '--color-hero-button-bg': '#f4871f', // Botão hero cor de palha
        '--color-hero-button-hover-bg': '#d6771b', // Palha mais escuro no hover
        '--color-hero-button-text': '#3B2B2A', // Texto escuro no botão hero
        '--bg-image-placeholder': '#4A3633',
        '--bg-carousel-nav': 'rgba(255, 255, 255, 0.7)',
        '--bg-carousel-nav-hover': '#FFFFFF',
        '--color-carousel-nav-icon': '#3B2B2A',
        '--bg-icon-hover-light': 'rgba(255, 255, 255, 0.08)',
        '--bg-tag': '#7e473f',
        '--color-tag-text': '#EDE7DF',
        '--bg-icon-button': '#4A3633', // Botões +/-
        '--color-icon-button-border': '#5E493F',
        '--color-icon-button-text': '#EDE7DF',
        '--bg-icon-button-hover': '#5E493F',
        '--bg-icon-button-disabled': '#3B2B2A',
        '--color-icon-button-disabled-text': '#9E867D',
        '--bg-button-disabled': '#5E493F',
        '--color-footer-link': '#D9A44E', // Link destaque em palha
        '--bg-modal-overlay': 'rgba(0, 0, 0, 0.8)',
    },
};